<script>
export default {
  name: 'TalkizyConnectActions',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLoginLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div>
    <div class="talkizyconnectactions_buttons mb-5">
      <b-tooltip
        v-if="disabled"
        label="Seul le propriétaire de l'espace peut connecter Talkizy."
        position="is-top"
        multilined
      >
        <b-button type="is-primary" size="is-medium" disabled>
          Créer un compte Talkizy
        </b-button>
      </b-tooltip>
      <b-button
        v-else
        type="is-primary"
        size="is-medium"
        :loading="isLoading"
        @click="$emit('register')"
      >
        Créer un compte Talkizy
      </b-button>

      <b-tooltip
        v-if="disabled"
        label="Seul le propriétaire de l'espace peut connecter Talkizy."
        position="is-top"
        multilined
      >
        <b-button type="is-primary" size="is-medium" outlined disabled>
          Se connecter à Talkizy
        </b-button>
      </b-tooltip>
      <b-button
        v-else
        type="is-primary"
        size="is-medium"
        outlined
        :loading="isLoginLoading"
        @click="$emit('login')"
      >
        Se connecter à Talkizy
      </b-button>
    </div>

    <p class="talkizyconnectactions_hint is-size-8 has-text-grey-dark">
      <b-icon icon="check-circle" size="is-small" type="is-primary" />
      Rapide
      <span class="mx-2">•</span>
      <b-icon icon="check-circle" size="is-small" type="is-primary" />
      Sécurisé
      <span class="mx-2">•</span>
      <b-icon icon="check-circle" size="is-small" type="is-primary" />
      Offre gratuite disponible
      <span class="mx-2">•</span>
      <b-icon icon="check-circle" size="is-small" type="is-primary" />
      Sans engagement
    </p>
  </div>
</template>

<style lang="scss" scoped>
.talkizyconnectactions {
  &_buttons {
    display: flex;
    justify-content: center;
    gap: 0.75rem;
    flex-wrap: wrap;

    .button {
      min-width: 220px;
    }
  }

  &_hint {
    .icon {
      vertical-align: middle;
    }
  }
}
</style>
